import { Checkbox } from 'semantic-ui-react';
import { ITypeHeaderProps } from 'components/contentTypes/CustomTypeInput';
import { useDispatch, useSelector } from 'react-redux';
import { entrySelector } from '../ArchiveHeader';
import { updateContent } from 'actions/ContentActions';
import { VideoPlayList } from '@visikon/core-models/models/content/video-lists';

export function PlayformReadyButton({ id, type }: ITypeHeaderProps) {
  const entry = useSelector(entrySelector(id, type)) as VideoPlayList;
  const dispatch = useDispatch();

  const isPlatformReady = entry?.platformReady === true;
  const togglePlatformTag = () => {
    if (!entry) return;

    const updatedEntry = {
      ...entry,
      platformReady: !isPlatformReady,
    };
    dispatch(updateContent(updatedEntry));
  };

  return <Checkbox toggle label="Platform Ready" checked={isPlatformReady} onChange={togglePlatformTag} disabled={!entry} />;
}
